// 하나의 key-value 수정
// updateObjectState(setLocalConditions, 'search', '검색어');
export function updateObjectState<S extends object, K extends keyof S>(
  setState: React.Dispatch<React.SetStateAction<S>>,
  key: K,
  value: S[K]
) {
  setState((prev) => ({ ...prev, [key]: value }));
}

// 여러 개 바꿀 때
// bulkUpdateObjectState(setLocalConditions, {
//   search: '검색어',
//   status: [1, 2, 3],
//   ownerDepartmentIds: [1001, 1002],
// });
export function bulkUpdateObjectState<S extends object>(
  setState: React.Dispatch<React.SetStateAction<S>>,
  partialState: Partial<S>
) {
  setState((prev) => ({ ...prev, ...partialState }));
}
